// app-details-modal.component.ts
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-app-details-modal',
  templateUrl: './app-details-modal.component.html',
  styleUrls: ['./app-details-modal.component.css']
})
export class AppDetailsModalComponent {


  constructor(public dialogRef: MatDialogRef<AppDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  async onSave(): Promise<void> {
    if ((this.data['cl_cd'] == undefined || this.data['cl_cd'] == null || this.data['cl_cd'] == "") || (this.data['cl_val'] == undefined || this.data['cl_val'] == null || this.data['cl_val'] == "")) {
      Swal.fire('Error!', `field required`, 'error');
      return;
    }
    else {
      this.data['cl_tcd_json']={"av_tcd":"SV"}
      this.dialogRef.close(this.data);
    }

  }
  onAdd(){

  }
  
}
